import styled from 'styled-components';
import Div from "../htmlTags/Div";
import Span from "../htmlTags/Span";
import { setColor } from '../../../helpers/styleUtils';
export const PointerOnHover = styled(Div)`
  cursor: pointer;
  &:hover {
    font-weight: bolder;
    color: ${setColor.scooter};
  }
`;
export const PointerOnHoverSpan = styled(Span)`
  cursor: pointer;
  &:hover {
    font-weight: bolder;
    color: ${setColor.scooter};
  }
`;